module.exports = __webpack_public_path__ + "img/quick.5b123f56.svg";